module.exports = __webpack_public_path__ + "images/360Suites_White.svg";